import { render, staticRenderFns } from "./presentation.vue?vue&type=template&id=39efb8d4&"
import script from "./presentation.vue?vue&type=script&lang=js&"
export * from "./presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports